import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

export const ReportsIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      {/* Barre menthe pleine au centre (la plus haute) */}
      <rect x="10.25" y="6" width="3.5" height="14.5" rx="1.25" fill="var(--equiply-icon-bg)" />
      {/* Barre gauche en trait bleu */}
      <rect x="3.75" y="13" width="3.5" height="7.5" rx="1.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Barre droite en trait bleu */}
      <rect x="16.75" y="10" width="3.5" height="10.5" rx="1.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
    </svg>
  ),
);
ReportsIcon.displayName = "ReportsIcon";
